module.exports = __webpack_public_path__ + "static/media/MI.9215274e.png";